import {Component, OnInit} from '@angular/core';
import {BreadcrumbsService} from '../../shared/components/breadcrumbs/breadcrumbs.service';

@Component({
    selector: 'kkk-email-list-index',
    templateUrl: './email-list-index.component.html',
})
export class EmailListIndexComponent implements OnInit {

    constructor(private _bc: BreadcrumbsService) {
    }

    ngOnInit() {
        this._bc.start({name: 'Email', instructions: ['/email']}).add('Email listák');
    }

}



// WEBPACK FOOTER //
// /Users/manuel/Development/kkk/frontend/src/app/email/email-list-index/email-list-index.component.ts